__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "agent-x";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth0/auth0-react", "2.3.0", () => (Promise.all([__webpack_require__.e(988), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(1988))))));
			register("axios", "1.8.4", () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(1914))))));
			register("clsx", "1.2.1", () => (__webpack_require__.e(976).then(() => (() => (__webpack_require__(4976))))));
			register("clsx", "2.1.1", () => (__webpack_require__.e(919).then(() => (() => (__webpack_require__(8919))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(6663))))));
			register("react-bootstrap", "2.10.9", () => (Promise.all([__webpack_require__.e(502), __webpack_require__.e(335), __webpack_require__.e(533), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(2502))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(653), __webpack_require__.e(533), __webpack_require__.e(977)]).then(() => (() => (__webpack_require__(5653))))));
			register("react-split", "2.0.14", () => (Promise.all([__webpack_require__.e(533), __webpack_require__.e(764)]).then(() => (() => (__webpack_require__(1764))))));
			register("react-tabs", "6.1.0", () => (Promise.all([__webpack_require__.e(533), __webpack_require__.e(843), __webpack_require__.e(161)]).then(() => (() => (__webpack_require__(8161))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(533), __webpack_require__.e(820), __webpack_require__.e(488)]).then(() => (() => (__webpack_require__(2488))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("socket.io-react-hook", "2.4.5", () => (Promise.all([__webpack_require__.e(875), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(8875))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};